import { cn, IconButton, useBreakpoints } from "@aurem/ui";
import { MenuIcon } from "lucide-react";
import { ReactNode } from "react";
import { useTranslations } from "../i18n";

type Props = {
  logoAlt?: string;
  logoUrl?: string | null;
  children?: ReactNode;
  footer?: ReactNode;
  open?: boolean;
  onClose?: () => void;
  className?: string;
};

export const PlatformSidebar = ({
  logoAlt = "",
  logoUrl,
  children,
  footer,
  open,
  onClose,
  className,
}: Props) => {
  const { isMobile } = useBreakpoints();
  const { t } = useTranslations();

  const mobileClassName =
    isMobile &&
    cn(
      "fixed z-[999] w-[8.25rem] h-[100dvh] left-0 rtl:left-auto rtl:right-0 transition-transform duration-300",
      open ? "translate-x-0" : "ltr:-translate-x-full rtl:translate-x-full",
    );

  const rootClass = cn(
    "relative flex w-[5.5rem] shrink-0 py-6 px-2 overflow-auto",
    "bg-accent-500 text-white border-r border-white/10",
    mobileClassName,
    className,
  );

  return (
    <aside className={rootClass}>
      <div className="flex flex-col items-center gap-6 w-[5.5rem]">
        {logoUrl && (
          <img
            src={logoUrl}
            alt={logoAlt}
            className="h-12 w-12 rounded-lg object-fill"
          />
        )}

        {children && (
          <ul className="flex flex-col w-full items-center gap-6 text-center">
            {children}
          </ul>
        )}

        {footer && (
          <ul className="flex flex-col w-full items-center gap-6 text-center mt-auto">
            {footer}
          </ul>
        )}
      </div>
      {isMobile && (
        <IconButton
          variant="ghost"
          color="neutral"
          size="md"
          aria-label={t("apps.admin.navBar.menu")}
          className="absolute top-[0.71875rem] end-1 text-white"
          onClick={onClose}
        >
          <MenuIcon />
        </IconButton>
      )}
    </aside>
  );
};
